import React from 'react';

const Telescope = () => {
    const telescopeUrl = process.env.REACT_APP_TELESCOPE_URL;

    if (!telescopeUrl) {
        return (
            <div style={{ padding: '24px', textAlign: 'center' }}>
                <h2>Telescope Not Configured</h2>
                <p>Please set REACT_APP_TELESCOPE_URL in your .env file.</p>
            </div>
        );
    }

    return (
        <div style={{ width: '100%', height: '100%', background: 'white', overflow: 'hidden' }}>
            <iframe 
                src={telescopeUrl} 
                title="Laravel Telescope" 
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </div>
    );
};

export default Telescope;
